import { Fragment, type ReactNode } from 'react';

/**
 * Render liviano de markdown INLINE (negrita / itálica / código) + saltos de línea.
 * El agente usa **negrita** para nombres de botones y rutas; sin esto se veían los
 * asteriscos crudos (****). Seguro: construye nodos React, sin dangerouslySetInnerHTML.
 */
function renderInline(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  // **negrita** | `código` | *itálica* | _itálica_
  const re = /(\*\*([^*]+)\*\*|`([^`]+)`|\*([^*\n]+)\*|_([^_\n]+)_)/g;
  let last = 0;
  let key = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    if (m[2] !== undefined) nodes.push(<strong key={key++}>{m[2]}</strong>);
    else if (m[3] !== undefined)
      nodes.push(
        <code key={key++} className="rounded bg-black/10 px-1 text-[0.85em]">
          {m[3]}
        </code>
      );
    else nodes.push(<em key={key++}>{m[4] ?? m[5]}</em>);
    last = re.lastIndex;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}

export function Markdown({ text, className }: { text: string; className?: string }) {
  const lines = text.split('\n');
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <Fragment key={i}>
          {renderInline(line)}
          {i < lines.length - 1 && <br />}
        </Fragment>
      ))}
    </div>
  );
}
